/**
 * O valor fixo de uma expressão JSONata, e o caminho de volta: o texto entre
 * aspas (`"F_VENDAS_NOVO"` ou `'aberta'`), o número, o sim ou não e o `null`.
 *
 * É o que deixa uma tela mostrar como escolha o que foi salvo como expressão,
 * sem ler JSONata: o que não for um valor fixo fica como expressão escrita.
 */

export type ValorFixo = string | number | boolean | null;

/** O valor fixo da expressão, ou `undefined` quando ela não é um valor fixo. */
export function valorFixo(expressao: string): ValorFixo | undefined {
  const texto = expressao.trim();
  if (texto === 'null') return null;
  if (texto === 'true') return true;
  if (texto === 'false') return false;
  if (/^-?\d+(\.\d+)?$/.test(texto)) return Number(texto);
  if (texto.startsWith('"')) {
    try {
      const lido: unknown = JSON.parse(texto);
      return typeof lido === 'string' ? lido : undefined;
    } catch {
      return undefined;
    }
  }
  const simples = /^'([^'\\]*)'$/.exec(texto);
  return simples ? simples[1]! : undefined;
}

/** O texto fixo da expressão, ou `null` quando ela não é um texto entre aspas. */
export function textoFixo(expressao: string): string | null {
  const v = valorFixo(expressao);
  return typeof v === 'string' ? v : null;
}

/** A expressão de um valor fixo: o texto vai entre aspas, com os escapes do JSON. */
export function expressaoDoValor(valor: ValorFixo): string {
  return valor === null ? 'null' : JSON.stringify(valor);
}
